import { Button, Classes, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { Dialog } from 'vet-bones/components';
import { redirectToPortalHome } from 'vet-bones/utils/portal';

import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const BrowserAuthFailedDialog: React.VFC = () => {
  const isOpen = useReduxSelector(
    (state) => state.ui.isBrowserAuthFailedDialogOpen
  );

  return (
    <Dialog
      autoFocus={false}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      enforceFocus={false}
      icon={IconNames.InfoSign}
      isCloseButtonShown={false}
      isOpen={isOpen}
      title={copy.components.browserAuthFailedDialog.title}
    >
      <div className={Classes.DIALOG_BODY}>
        {copy.components.browserAuthFailedDialog.message}
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            icon={IconNames.HOME}
            intent={Intent.PRIMARY}
            onClick={() => {
              redirectToPortalHome(window);
            }}
            text={copy.components.browserAuthFailedDialog.homeButton}
          />
        </div>
      </div>
    </Dialog>
  );
};
